module.exports = __webpack_public_path__ + "2aace89c22caaf4f675810ba000a2601.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-70@2x.png
// module id = 533
// module chunks = 0